<template>
  <ol class="breadcrumb">
    <li class="breadcrumb-item" v-for="(item, index) in list">
      <span class="active" v-if="isLast(index) || isDisabled(item)">{{ showName(item) }}</span>
      <router-link :to="path(item)" v-else>{{ showName(item) }}</router-link>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    },
    separator: String
  },
  methods: {
    isLast (index) {
      return index === this.list.length - 1
    },
    isDisabled (item) {
      return item.meta && item.meta.disabled
    },
    showName (item) {
      return (item.meta && item.meta.label) || item.name
    },
    path (item) {
      return item.path || '/'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue